import { Box, Chip, Stack, Typography } from "@mui/material";
import { STATUS_COLORS } from "../../../utils/statusConstants";
import { formattedDate } from "../../../utils/dateUtils";
import { isCurrentCulture } from "../utils";

const InfoBox = ({
  theme,
  cultureName,
  cultureStartDate,
  cultureEndDate,
  isCurrentCulture = false,
}) => {
  return (
    <Box
      width="100%"
      height="85px"
      sx={{
        backgroundColor: theme.palette.custom.backgroundColor,
        borderRadius: "2px",
      }}
      p={1}
      display="flex"
      alignItems="center"
    >
      <Stack direction="column" spacing={2} width="100%">
        <Box
          display="flex"
          width="100%"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography fontSize="14px" fontWeight="bold">
            {cultureName}
          </Typography>
          {isCurrentCulture && (
            <Chip
              label="Attuale"
              size="small"
              sx={{
                color: STATUS_COLORS.Confermato.text,
                backgroundColor: STATUS_COLORS.Confermato.background,
              }}
            />
          )}
        </Box>
        {/* time range */}
        <Stack direction="row" spacing={2}>
          <Box
            display="flex"
            flexDirection="column"
            width="100%"
            alignItems="start"
            justifyContent="space-between"
          >
            <Typography
              fontSize="8px"
              color={theme.palette.custom.infoTextColor}
            >
              Dal
            </Typography>
            <Typography fontSize="14px">
              {formattedDate(cultureStartDate)}
            </Typography>
          </Box>
          <Box
            display="flex"
            flexDirection="column"
            width="100%"
            alignItems="start"
            justifyContent="space-between"
          >
            <Typography
              fontSize="8px"
              color={theme.palette.custom.infoTextColor}
            >
              Al
            </Typography>
            <Typography fontSize="14px">
              {formattedDate(cultureEndDate)}
            </Typography>
          </Box>
        </Stack>
      </Stack>
    </Box>
  );
};

const CropHistoryTabPanel = ({ theme, field }) => {
  const lastCulture = field?.field_colture
    ? field?.field_colture[field.field_colture.length - 1]
    : undefined;
  const currentCulture = isCurrentCulture(lastCulture);
  const cropHistory = field?.field_colture?.slice(0, -1);
  const sortedCropHistory = [...cropHistory].sort((a, b) => {
    return new Date(b.end_date) - new Date(a.end_date);
  });
  return (
    <Box
      width="100%"
      height="100%"
      py={2}
      display="flex"
      flexDirection="column"
      gap={2}
      alignItems="center"
    >
      {field?.field_colture.length > 0 ? (
        <>
          {currentCulture && (
            <InfoBox
              theme={theme}
              cultureName={lastCulture?.colture?.name}
              cultureStartDate={lastCulture?.start_date}
              cultureEndDate={lastCulture?.end_date}
              isCurrentCulture
            />
          )}
          {sortedCropHistory.map((culture, index) => (
            <InfoBox
              key={index}
              theme={theme}
              cultureName={culture?.colture?.name}
              cultureStartDate={culture?.start_date}
              cultureEndDate={culture?.end_date}
            />
          ))}
        </>
      ) : (
        <Typography fontSize="14px">Nessuna coltura inserita</Typography>
      )}
    </Box>
  );
};

export default CropHistoryTabPanel;
